import type { FaireProductEntity } from "../../entity_types/product";

export const p_a8sh7xvegq: FaireProductEntity = {
  token: "p_a8sh7xvegq",
  type: "product",
  name: "Hen on a nest trinket dish (3d printed)",
  brandName: "Eastbrook Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/607a3d5527f132677eb50b181205d36fd9c34a4cf9300dda07627a8f1dc47ddb.jpeg",
  priceDollars: 7.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65851233dc1e68d8b83db16c10c498ae0388ebb59e4aeec6e96fc6bc46bee867.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
